import gql from "graphql-tag";

import { fragments as userFragments } from "/imports/api/users/apollo/fragments";

export const LOGIN_WITH_PASSWORD_MUTATION = gql`
  mutation loginWithPassword($input: LoginWithPasswordInput!) {
    loginWithPassword(input: $input) {
      token
      userId
      user {
        ...userCore
      }
    }
  }
  ${userFragments.userCore}
`;

export const LOGIN_WITH_ROUTE_TOKEN_MUTATION = gql`
  mutation loginWithRouteToken($token: String!) {
    loginWithRouteToken(token: $token) {
      route {
        _id
        page
        section
      }
      token
      userId
      user {
        ...userCore
      }
      reason
      err
    }
  }
  ${userFragments.userCore}
`;

export const LOGOUT_MUTATION = gql`
  mutation($token: String!) {
    logout(token: $token)
  }
`;

export const FORGET_PASSWORD_MUTATION = gql`
  mutation($email: String!) {
    forgetPassword(email: $email)
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;
